module.exports={
  "_args": [
    [
      "npm-registry-fetch@1.1.0",
      "C:\\Projects\\TBF\\Source"
    ]
  ],
  "_from": "npm-registry-fetch@1.1.0",
  "_id": "npm-registry-fetch@1.1.0",
  "_inBundle": true,
  "_integrity": "sha512-XJPIBfMtgaooRtZmuA42xCeLf3tkxdIX0xqRsGWwNrcVvJ9UYFccD7Ho7QWCzvkM3i/QrkUC37Hu0a+vDBmt5g==",
  "_location": "/npm/npm-registry-fetch",
  "_phantomChildren": {
    "agent-base": "4.2.0",
    "agentkeepalive": "3.4.1",
    "bluebird": "3.5.1",
    "chownr": "1.0.1",
    "concat-stream": "1.6.2",
    "duplexify": "3.6.0",
    "end-of-stream": "1.4.1",
    "flush-write-stream": "1.0.3",
    "from2": "2.3.0",
    "glob": "7.1.2",
    "graceful-fs": "4.1.11",
    "http-cache-semantics": "3.8.1",
    "http-proxy-agent": "2.1.0",
    "https-proxy-agent": "2.2.1",
    "ip": "1.1.5",
    "lru-cache": "4.1.3",
    "mississippi": "3.0.0",
    "mkdirp": "0.5.1",
    "move-concurrently": "1.0.1",
    "node-fetch-npm": "2.0.2",
    "once": "1.4.0",
    "parallel-transform": "1.1.0",
    "promise-inflight": "1.0.1",
    "promise-retry": "1.1.1",
    "pumpify": "1.5.1",
    "rimraf": "2.6.2",
    "safe-buffer": "5.1.2",
    "stream-each": "1.2.2",
    "through2": "2.0.3",
    "unique-filename": "1.1.0",
    "y18n": "4.0.0"
  },
  "_requested": {
    "type": "version",
    "registry": true,
    "raw": "npm-registry-fetch@1.1.0",
    "name": "npm-registry-fetch",
    "escapedName": "npm-registry-fetch",
    "rawSpec": "1.1.0",
    "saveSpec": null,
    "fetchSpec": "1.1.0"
  },
  "_requiredBy": [
    "/npm"
  ],
  "_resolved": "https://registry.npmjs.org/npm-registry-fetch/-/npm-registry-fetch-1.1.0.tgz",
  "_spec": "1.1.0",
  "_where": "C:\\Projects\\TBF\\Source",
  "author": {
    "name": "Kat Marchán",
    "email": "kzm@sykosomatic.org"
  },
  "bugs": {
    "url": "https://github.com/npm/registry-fetch/issues"
  },
  "config": {
    "nyc": {
      "exclude": [
        "node_modules/**",
        "test/**"
      ]
    }
  },
  "dependencies": {
    "bluebird": "^3.5.1",
    "figgy-pudding": "^2.0.1",
    "lru-cache": "^4.1.2",
    "make-fetch-happen": "^3.0.0",
    "npm-package-arg": "^6.0.0",
    "safe-buffer": "^5.1.1"
  },
  "description": "Fetch-based http client for use with npm registry APIs",
  "devDependencies": {
    "cacache": "^10.0.4",
    "mkdirp": "^0.5.1",
    "nock": "^9.2.3",
    "npmlog": "^4.1.2",
    "rimraf": "^2.6.2",
    "ssri": "^5.3.0",
    "standard": "^11.0.1",
    "standard-version": "^4.2.0",
    "tap": "^11.1.2",
    "weallbehave": "^1.2.0",
    "weallcontribute": "^1.0.8"
  },
  "files": [
    "*.js",
    "lib"
  ],
  "homepage": "https://github.com/npm/registry-fetch#readme",
  "keywords": [
    "npm",
    "registry",
    "fetch"
  ],
  "license": "ISC",
  "main": "index.js",
  "name": "npm-registry-fetch",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/npm/registry-fetch.git"
  },
  "scripts": {
    "postrelease": "npm publish && git push --follow-tags",
    "prerelease": "npm t",
    "pretest": "standard",
    "release": "standard-version -s",
    "test": "tap -J --coverage test/*.js",
    "update-coc": "weallbehave -o . && git add CODE_OF_CONDUCT.md && git commit -m 'docs(coc): updated CODE_OF_CONDUCT.md'",
    "update-contrib": "weallcontribute -o . && git add CONTRIBUTING.md && git commit -m 'docs(contributing): updated CONTRIBUTING.md'"
  },
  "version": "1.1.0"
}
